import {Outlet} from 'react-router-dom';


import {
    FlexiSignInButton,
    PlatformAppShell,
    PlatformFooter,
    PlatformHeader,
    PlatformHeaderNavigationMenu,
    PlatformHeaderToolbar,
    PlatformLoader,
} from '@flexinet/ui-components';


import {Suspense} from "react";
import {signInWithRedirect} from 'aws-amplify/auth';


export const PublicLayout = () => {

    const menuItems = [] as { title: string, onClick: () => void }[]

    const additionalToolbarItems = [
        <FlexiSignInButton
            onClick={() => {
                signInWithRedirect()
            }}>Sign in</FlexiSignInButton>,
    ]

    return <PlatformAppShell
        platformHeader={<PlatformHeader
            navigationMenu={<PlatformHeaderNavigationMenu menuItems={menuItems}/>}
            toolbar={<PlatformHeaderToolbar additionalToolbarItems={additionalToolbarItems}/>}/>}
        platformFooter={<PlatformFooter/>}
        header={{height: 80}}
        footer={{height: 100}}
        navbar={{
            width: 0,
            breakpoint: 'sm',
        }}
    >

        <Suspense fallback={<PlatformLoader/>}>
            <Outlet/>
        </Suspense>

    </PlatformAppShell>


};
